import { useQuery, type UseQueryOptions } from '@tanstack/react-query';
import { getClientEnvs } from '@/services/clientEnv-service/clientEnv-service';
import type { ClientEnv } from '@/types/client-env';
import { queryClient } from '@/routes';

export function clientEnvsQuery() {
  return {
    queryKey: ['clientEnvs'],
    queryFn: () => getClientEnvs(),
    initialData: (queryClient.getQueryData(['clientEnvs']) ?? {}) as ClientEnv,
  } satisfies UseQueryOptions;
}

export function useClientEnvs() {
  return useQuery(clientEnvsQuery());
}
